import { Box, Heading, Spacer, Text, VStack } from '@chakra-ui/react';
import { memo } from 'react';
import { ILoginSlider } from './Slider.model';
import { overlayStyle, sliderItemStyle } from './Slider.styles';

interface IProps {
  item?: ILoginSlider;
}
const SliderItem: React.FC<IProps> = ({ item }): JSX.Element => {
  return (
    <Box {...sliderItemStyle} bgImage={item?.bg}>
      <VStack w="full" spacing="3" align="stretch" zIndex="99">
        <Heading size="md">{item.title}</Heading>
        <Text color="white" fontSize="md" fontWeight="medium">
          {item?.description}
        </Text>
        <Spacer />
        <Text color="white">{item?.footer}</Text>
      </VStack>
      <Box {...overlayStyle} />
    </Box>
  );
};

export default memo(SliderItem);
